export class StatusVm{
    Id: number = 0;
    NameEN: string = "";
    NameDK: string = "";

}

